class ScrollToHelper {
    static scrollTo(element = null, additionalSpacing = ScrollToHelper.getHeaderHeight()) {
        let scrollTop = window.pageYOffset;

        if (window.pageYOffset === undefined) {
            [scrollTop] = (document.documentElement || document.body.parentNode || document.body);
        }

        const computedStyle = window.getComputedStyle(element);
        let scrollMarginBlockStart = 0;
        if (computedStyle) {
            const scrollMarginBlockStartWithUnit = computedStyle.getPropertyValue('scroll-margin-block-start');
            scrollMarginBlockStart = parseFloat(scrollMarginBlockStartWithUnit);
        }

        let top = element !== null ? element.getBoundingClientRect().top - scrollMarginBlockStart + scrollTop : 0;

        if (additionalSpacing !== 0) {
            top -= additionalSpacing;
        }

        window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top,
        });
    }

    static getElementTopOffset(element = null) {
        let scrollTop = window.pageYOffset;

        if (window.pageYOffset === undefined) {
            [scrollTop] = (document.documentElement || document.body.parentNode || document.body);
        }

        return element !== null ? element.getBoundingClientRect().top + scrollTop : 0;
    }

    static getHeaderHeight() {
        return document.querySelector('.page-header').getBoundingClientRect().height;
    }
}

export default ScrollToHelper;
